import { useCallback, useRef } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import clsx from "clsx";
import { Paper } from "@mui/material";
import { getSessionId } from "../../../../../utils/edReviewUtils";
import PatientToBeSeenCtx from "../../../../reusable/patientToBeSeenCtx";
import LockedSlotTile from "./lockedSlotTile";
import AvailableSlotTile from "./availableSlotTile";
import { useDailyCalendarTileStyles } from "./dailyCalendarTileStyles";
import { openAppointmentModal } from "../../../../../../../store/reducers/appointments";
import { APPOINTMENT_MODALS } from "../../../../../utils/constants/appointmentSessionConstants";

const DailyCalendarTile = ({
  id,
  event,
  options,
  session,
  selected,
  locked,
  availableSlot,
  temporaryLock,
}) => {
  const dispatch = useDispatch();
  const classes = useDailyCalendarTileStyles({
    sessionName: event?.sessionName || "",
  });

  const sessionPaperRef = useRef();

  const onClickAvailableSlot = (ev) => {
    // onButtonClick(ev);

    dispatch(
      openAppointmentModal(APPOINTMENT_MODALS.ASSIGN_SESSION, {
        hour: event?.slot?.startDate,
        session: event?.session,
      }),
    );
  };

  const eventId = getSessionId(event);

  return session ? (
        <Paper
            key={eventId}
            id={availableSlot || locked || temporaryLock ? null : id}
            ref={sessionPaperRef}
            className={clsx(
                classes.session,
                locked && "locked",
                temporaryLock && "temporary",
                selected && "selected",
                availableSlot && "available",
                classes.animation,
            )}
            style={{
              top: options.top,
              left: options.left,
              width: options.width,
              height: options.height,
              zIndex: availableSlot ? 101 : locked ? 103 : 1,
              cursor: options.cursor
                  ? options.cursor
                  : availableSlot
                      ? "pointer"
                      : "default,",
            }}
        >
          {availableSlot ? (
              <AvailableSlotTile
                  event={event}
                  onClickAvailableSlot={onClickAvailableSlot}
              />
          ) : locked || temporaryLock ? (
              <LockedSlotTile
                  event={event}
                  temporaryLock={temporaryLock}
              />
          ) : (
              <div />
          )}
        </Paper>
    ) : (
        <Paper
            id={id}
            key={eventId}
            className={classes.review}
            style={{
              top: options.top,
              left: options.left,
              width: options.width,
              height: options.height,
              padding: locked && 0
            }}
        >
          {(locked || temporaryLock) ? (
              <LockedSlotTile
                  event={event}
                  temporaryLock={temporaryLock}
              />
          ) : (
              <PatientToBeSeenCtx
                  ptInWard={event?.appointmentReview ?? event}
                  calendarView
              />
          )}
        </Paper>
    );
};

DailyCalendarTile.propTypes = {
  event: PropTypes.object.isRequired,
  options: PropTypes.object.isRequired,
  session: PropTypes.bool,
  selected: PropTypes.bool,
  locked: PropTypes.bool,
  availableSlot: PropTypes.bool,
  temporaryLock: PropTypes.bool,
  onSelectTime: PropTypes.func,
  changeLockedReason: PropTypes.func,
  deleteTemporaryLockedSession: PropTypes.func,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

DailyCalendarTile.defaultProps = {
  locked: false,
  session: false,
  selected: false,
  availableSlot: false,
  temporaryLock: false,
};

export default DailyCalendarTile;
